import React, { useState } from 'react';

const logoServicesData = [
  {
    id: 'custom-logo',
    title: 'Custom Logo Design',
    content:
      'Personalization is a must-have for every business so that it can keep itself unique from other competitors in the industry. To be on top, you need to invest in your company logo design that can address the unique needs of the brand’s identity. At our digital marketing and logo design company online, we never go with the idea that one solution fits all. We see every business as a blank canvas where we can show our creativity. If your logo should have uniqueness and creativity, then you should go with our custom logo design services.'
  },
  {
    id: '3d-logo',
    title: '3D Logo Design',
    content:
      'Elevate your visual presence with stunning depth, lighting effects, and lifelike realism. Our 3D logo design service transforms traditional emblems into dynamic, multi-dimensional brand symbols that captivate modern audiences. Perfect for tech companies, modern enterprises, multimedia studios, and digital agencies, our 3D logos create an unforgettable high-impact impression across digital displays, presentations, and premium packaging.'
  },
  {
    id: '2d-logo',
    title: '2D Logo Design',
    content:
      'Embrace timeless clarity with sleek, minimalist 2D logo designs. Clean lines, balanced geometry, and modern aesthetic precision ensure your logo looks sharp and instantly recognizable on everything from a tiny website favicon to large-scale print collateral. We craft flat, elegant emblems that articulate your company’s core values with unmatched versatility, readability, and sophistication.'
  },
  {
    id: 'brand-logo',
    title: 'Brand Logo Design',
    content:
      'A brand logo is more than just graphics; it is the cornerstone of your comprehensive visual identity system. We architect cohesive brand emblems, iconographies, typography suites, and color palettes that harmonize across every brand touchpoint. Our strategic branding process empowers startups and established enterprises to establish market authority, cultivate emotional customer connections, and foster lifelong brand loyalty.'
  },
  {
    id: 'name-logo',
    title: 'Name Logo Design',
    content:
      'Make your company’s name the focal point with bespoke typography and custom wordmark logo designs. Our typographic craftsmen engineer tailored letterforms, hand-crafted ligatures, and distinctive font treatments that give your business name an authoritative and memorable identity. A custom name logo guarantees immediate name recall and establishes instant credibility in competitive markets.'
  },
  {
    id: 'mascot-logo',
    title: 'Mascot Logo Design',
    content:
      'Inject vibrant personality, charisma, and friendly engagement into your brand with custom mascot logo designs. Whether you need a bold character for sports and gaming, an approachable guide for service brands, or a lively mascot for food and retail products, our illustrators design bespoke characters that forge an immediate, lasting bond with your target audience.'
  }
];

function LogoServicesTabs() {
  const [activeTabId, setActiveTabId] = useState('custom-logo');

  const activeService =
    logoServicesData.find((item) => item.id === activeTabId) || logoServicesData[0];

  return (
    <section className="bpo-tabs-section logo-tabs-section">
      <div className="container">
        {/* Section Header: Title on Left, Paragraphs on Right */}
        <div className="bpo-tabs-header-row">
          <div className="bpo-tabs-header-left">
            <h2 className="bpo-tabs-main-title">
              Explore Our Custom Logo Design Services
            </h2>
          </div>
          <div className="bpo-tabs-header-right">
            <p className="bpo-tabs-header-p">
              In today’s fast digital world, navigating the landscape of IT services and technology can feel overwhelming, especially for businesses that focus on growth rather than gadgets.
            </p>
            <p className="bpo-tabs-header-p">
              In today’s fast digital world, navigating the landscape of IT services and technology can feel overwhelming, especially for businesses that focus on growth rather than gadgets.
            </p>
          </div>
        </div>

        {/* Tabs & Content Layout */}
        <div className="bpo-tabs-main-grid">
          {/* Left Side: Vertical Tabs List with Black Background */}
          <div className="bpo-tabs-sidebar">
            <ul className="bpo-tabs-list">
              {logoServicesData.map((item) => {
                const isActive = item.id === activeTabId;
                return (
                  <li key={item.id} className="bpo-tab-item">
                    <button
                      className={`bpo-tab-button ${isActive ? 'active' : ''}`}
                      onClick={() => setActiveTabId(item.id)}
                    >
                      {item.title}
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Right Side: Tab Details Content */}
          <div className="bpo-tab-content-card logo-tab-content-card">
            <p className="logo-tab-content-text">
              {activeService.content}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LogoServicesTabs;
